import React from 'react';

/**
 * PiSidebarRightCloseStroke icon from the stroke style in arrows-&-navigation category.
 */
interface PiSidebarRightCloseStrokeProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  className?: string;
  ariaLabel?: string;
}

export default function PiSidebarRightCloseStroke({
  size = 24,
  color,
  className,
  ariaLabel = 'sidebar-right-close icon',
  ...props
}: PiSidebarRightCloseStrokeProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      stroke="currentColor" strokeWidth="1.39" strokeLinecap="round" strokeLinejoin="round" style={{color: color || "currentColor"}}
      role="img"
      aria-label={ariaLabel}
      {...props}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.39" d="M10 2.00736C11.0261 2.02701 11.6614 2.09906 12.18 2.36331C12.8072 2.68289 13.3171 3.19282 13.6367 3.82003C14 4.53307 14 5.46649 14 7.33333V8.66667C14 10.5335 14 11.4669 13.6367 12.18C13.3171 12.8072 12.8072 13.3171 12.18 13.6367C11.6614 13.9009 11.0261 13.973 10 13.9926C9.61532 14 9.17569 14 8.66667 14H7.33333C5.46649 14 4.53307 14 3.82003 13.6367C3.19282 13.3171 2.68289 12.8072 2.36331 12.18C2 11.4669 2 10.5335 2 8.66667V7.33333C2 5.46649 2 4.53307 2.36331 3.82003C2.68289 3.19282 3.19282 2.68289 3.82003 2.36331C4.53307 2 5.46649 2 7.33333 2H8.66667C9.17569 2 9.61532 2 10 2.00736ZM10 13.9926L10 2.00736M5 6C5.73094 6.53103 6.38564 7.15354 6.9471 7.85106C7.01763 7.93869 7.01763 8.06132 6.9471 8.14894C6.38564 8.84646 5.73094 9.46897 5 10" fill="none"/>
    </svg>
  );
}
